import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlertifyService,  ProjectService, UtilsService, AuthService } from 'core';


@Component({
  selector: 'app-health-config',
  templateUrl: './health-config.component.html',
  styleUrls: ['./health-config.component.scss']
})
export class HealthConfigComponent implements OnInit {

  configSelected = false;
  selectedConfigId;
  model: any;
  editForm: FormGroup;
  nameValid;
  instanceId = '';
  defaultSettings: string;
  expectedDoubleValue;

  tabselector;

  projectSettings: any[];
  configName: string;
  configDesc: string;
  inputVal: string;
  starts: any[];
  pace: any[];
  qc: any[];
  fraud: any[];

  
  layout = [
    {label: 'Name', id: 'configName', sortable: true},
    {label: 'Description', id: 'description'},
    //{label: 'Last Updated', id: 'lastUpdated', sortable: true},
    {label: 'Actions', type: 'actions-inline'}
  ];

  actions = [
    {label: 'Edit', type: 'edit', icon: 'pen-square'},
    {label: 'Delete', type: 'delete', icon: 'trash-alt'}
  ];

  configs = [];

  irXLabel = "Expected IR (%)"
  irYLabel = "Actual IR (%)"
  irType = "percent"
  irSign = "%"
  ir = []

  totalTestScore: number;
  tests: any[];
  
  
  @ViewChild('cidtab1') public cidtab1;



  constructor(
    private projectService: ProjectService, 
    private alertify: AlertifyService,
    public auth: AuthService,
    public utils: UtilsService) { 
  }

  ngOnInit(): void {
    this.instanceId = this.auth.getInstance();
    this.setup();
    this.defaultSettings = '[{"type":"qc","settings":[{"id":0,"percentage":1,"value":8},{"id":1,"percentage":11,"value":10}]},{"type":"ir","settings":[{"actual":"1","links":[{"expected":1,"value":0},{"expected":2,"value":1},{"expected":3,"value":2},{"expected":4,"value":5},{"expected":5,"value":10},{"expected":10,"value":null},{"expected":15,"value":null},{"expected":20,"value":null},{"expected":25,"value":null},{"expected":30,"value":null},{"expected":40,"value":null},{"expected":50,"value":null},{"expected":75,"value":null}]},{"actual":"2","links":[{"expected":1,"value":""},{"expected":2,"value":0},{"expected":3,"value":1},{"expected":4,"value":2},{"expected":5,"value":7},{"expected":10,"value":8},{"expected":15,"value":10},{"expected":20,"value":null},{"expected":25,"value":null},{"expected":30,"value":null},{"expected":40,"value":null},{"expected":50,"value":null},{"expected":75,"value":null}]},{"actual":"3","links":[{"expected":1,"value":1},{"expected":2,"value":0},{"expected":3,"value":0},{"expected":4,"value":1},{"expected":5,"value":null},{"expected":10,"value":7},{"expected":15,"value":8},{"expected":20,"value":10},{"expected":25,"value":null},{"expected":30,"value":null},{"expected":40,"value":null},{"expected":50,"value":null},{"expected":75,"value":null}]},{"actual":"4","links":[{"expected":1,"value":2},{"expected":2,"value":null},{"expected":3,"value":0},{"expected":4,"value":0},{"expected":5,"value":null},{"expected":10,"value":4},{"expected":15,"value":5},{"expected":20,"value":10},{"expected":25,"value":null},{"expected":30,"value":null},{"expected":40,"value":null},{"expected":50,"value":null},{"expected":75,"value":null}]},{"actual":"5","links":[{"expected":1,"value":3},{"expected":2,"value":2},{"expected":3,"value":1},{"expected":4,"value":0},{"expected":5,"value":0},{"expected":10,"value":2},{"expected":15,"value":null},{"expected":20,"value":5},{"expected":25,"value":7},{"expected":30,"value":10},{"expected":40,"value":null},{"expected":50,"value":null},{"expected":75,"value":null}]},{"actual":"10","links":[{"expected":1,"value":4},{"expected":2,"value":3},{"expected":3,"value":2},{"expected":4,"value":1},{"expected":5,"value":0},{"expected":10,"value":0},{"expected":15,"value":null},{"expected":20,"value":2},{"expected":25,"value":3},{"expected":30,"value":4},{"expected":40,"value":7},{"expected":50,"value":null},{"expected":75,"value":10}]},{"actual":"15","links":[{"expected":1,"value":5},{"expected":2,"value":4},{"expected":3,"value":3},{"expected":4,"value":2},{"expected":5,"value":1},{"expected":10,"value":0},{"expected":15,"value":0},{"expected":20,"value":null},{"expected":25,"value":1},{"expected":30,"value":3},{"expected":40,"value":null},{"expected":50,"value":5},{"expected":75,"value":10}]},{"actual":"20","links":[{"expected":1,"value":6},{"expected":2,"value":5},{"expected":3,"value":4},{"expected":4,"value":3},{"expected":5,"value":2},{"expected":10,"value":1},{"expected":15,"value":0},{"expected":20,"value":0},{"expected":25,"value":null},{"expected":30,"value":1},{"expected":40,"value":3},{"expected":50,"value":4},{"expected":75,"value":10}]},{"actual":"25","links":[{"expected":1,"value":7},{"expected":2,"value":6},{"expected":3,"value":5},{"expected":4,"value":4},{"expected":5,"value":3},{"expected":10,"value":2},{"expected":15,"value":1},{"expected":20,"value":0},{"expected":25,"value":0},{"expected":30,"value":null},{"expected":40,"value":1},{"expected":50,"value":3},{"expected":75,"value":10}]},{"actual":"30","links":[{"expected":1,"value":8},{"expected":2,"value":7},{"expected":3,"value":6},{"expected":4,"value":5},{"expected":5,"value":4},{"expected":10,"value":3},{"expected":15,"value":2},{"expected":20,"value":1},{"expected":25,"value":0},{"expected":30,"value":0},{"expected":40,"value":null},{"expected":50,"value":1},{"expected":75,"value":5}]},{"actual":40,"links":[{"expected":"1","value":9},{"expected":"2","value":8},{"expected":"3","value":7},{"expected":"4","value":6},{"expected":"5","value":5},{"expected":"10","value":4},{"expected":"15","value":3},{"expected":"20","value":2},{"expected":"25","value":1},{"expected":"30","value":0},{"expected":40,"value":0},{"expected":50,"value":null},{"expected":75,"value":3}]},{"actual":50,"links":[{"expected":"1","value":10},{"expected":"2","value":9},{"expected":"3","value":8},{"expected":"4","value":7},{"expected":"5","value":6},{"expected":"10","value":5},{"expected":"15","value":4},{"expected":"20","value":3},{"expected":"25","value":2},{"expected":"30","value":1},{"expected":40,"value":0},{"expected":50,"value":0},{"expected":75,"value":1}]},{"actual":75,"links":[{"expected":"1","value":10},{"expected":"2","value":""},{"expected":"3","value":9},{"expected":"4","value":8},{"expected":"5","value":7},{"expected":"10","value":6},{"expected":"15","value":5},{"expected":"20","value":4},{"expected":"25","value":3},{"expected":"30","value":2},{"expected":40,"value":1},{"expected":50,"value":0},{"expected":75,"value":0}]}]},{"type":"pace","settings":[{"negPace":1}]},{"type":"starts","settings":[{"value":"5"}]}]';

    //this.ir = this.createTestData();


    this.editForm = new FormGroup({
      configName: new FormControl('', [Validators.required, Validators.maxLength(40)]),
      configDesc: new FormControl('', Validators.maxLength(100)),
    })
  }

  setup() {
    this.getAllConfigs();
    this.configSelected = false;

    this.totalTestScore = 0;
    this.tabselector = 'tab1';

    this.nameValid = true;
    this.selectedConfigId = '';
    this.projectSettings = [];
    this.configName = '';
    this.configDesc = '';
    this.inputVal = null;
  
    this.starts = [];
  
    this.pace = [];
    this.qc = [];
    this.fraud = [];

    this.tests = [
      {id:0, testType: "Starts", value: null},
      {id:1, testType: "IR", expected: null, actual: null, score:null},
      {id:2, testType: "QC", expected: null, actual: null, score:null},
      {id:3, testType: "Fraud", expected: null, actual: null, score:null},
      {id:4, testType: "Pace", negPace:false, score: null}
    ];
  }

  initialiseData(){
    
    this.totalTestScore = 0;
    this.configSelected = true;
    this.starts = [{value: null}];
    this.pace = [{negPace: null}];
    this.qc = [{percentage: 1, value: 8}, {percentage: 11, value: 10}];
    this.fraud = [{percentage: 1, value: 8}, {percentage: 7, value: 10}];

    this.ir = this.createData(this.ir=[]);
  }

  createNewConfig(){
    
    this.initialiseData();
    var settings = JSON.parse(this.defaultSettings);
    this.fillInData(settings);
  }

  handleAction(action) {
    if (action.type === 'edit') {
      this.editConfig(action.row);
    }
    if (action.type === 'delete') {
      this.deleteConfig(action.row.id);
    }
  }

  cloneConfig(config) {
    this.projectSettings = config.settings
    this.configName = config.configName + " - Copy"
    this.configDesc = config.description
    this.saveHealthConfig();
  }

  fillInData(settings){

    for (var i = 0; i < settings.length; i++) {
      if (settings[i].settings.length > 0){
        if (settings[i].type === 'qc') {
          this.qc = settings[i].settings;
        }
        else if (settings[i].type === 'fraud') {
          this.fraud = settings[i].settings;
        }
        else if (settings[i].type === 'ir') {
          this.ir = settings[i].settings;
        }
        else if (settings[i].type === 'pace') {
          this.pace = settings[i].settings
        }
        else if (settings[i].type === 'starts') {
          this.starts = settings[i].settings
        }
      } 
    }
  }

  editConfig(config) {
    
    this.tabselector = 'tab1';
    this.initialiseData();
    var settings = config.settings
    this.fillInData(settings)

    this.configName = config.configName;
    this.configDesc = config.description;
    var id = config.id;
    this.selectedConfigId = id;

  }

  deleteConfig(id) {

    this.alertify.confirmYesNo(
      `Are you sure you want to delete?`,
      `This may affect any projects that have been set to use this health configuration.\nAre you sure you want to continue? `,
      () => {
        this.projectService.DeleteProjectHealthConfig(id).subscribe( data => {
          this.alertify.success('Health Configuration deleted.');
          this.getAllConfigs();
        }, error => {
          this.alertify.error('There was a problem with deleting the configuration.');
        });
      },
      () => {

        });
      }
    

  createData(dataGrid): any[] {
    if (dataGrid.length == 0){
      var numbers = [ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
      for (var _x = 0; _x < numbers.length; _x++) {
        dataGrid.push({actual: null, links: []})
        for (var _y = 0; _y < numbers.length; _y++) {
          dataGrid[_x]['links'].push({expected: null, value: null})
        }
      }
    }
    else {
      dataGrid = []
    }
    return dataGrid
  }

  createTestData() {
    var xVals = ['1', '2', '3', '4', '5', '10', '15', '20', '25', '30', '40', '50', '75']
    var irData2 = [];
    var valueLength2 = 0;
    var scoreList = [
      [0, 1, 2, 5, 10, 10, 10, 10, 10, 10, 10, 10, 10],
      [0, 0, 1, 2, 7, 8, 10, 10, 10, 10, 10, 10, 10],
      [1, 0, 0, 1, 1, 7, 8, 10, 10, 10, 10, 10, 10],
      [2, 1, 0, 0, 0, 4, 5, 10, 10, 10, 10, 10, 10],
      [3, 2, 1, 0, 0, 2, 2, 5, 7, 10, 10, 10, 10],
      [4, 3, 2,	1, 0, 0, 0, 2, 4, 3, 7, 7, 10],
      [5, 4, 3, 2, 1, 0, 0, 0, 1, 3, 3, 5, 10],
      [6, 5, 4, 3, 2, 1, 0, 0, 0, 1, 3, 4, 10],
      [7, 6, 5, 4, 3, 2, 1, 0, 0, 0, 1, 3, 10],
      [8, 7, 6, 5, 4, 3, 2, 1, 0, 0, 0, 1, 5],
      [9, 8, 7, 6, 5, 4, 3, 2, 1, 0, 0, 0, 3],
      [10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0, 0, 1],
      [10, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1, 0, 0]
      ];
    
    for (var _y=0; _y < xVals.length; _y ++) {
      var newColLink = [];
      for (var _x = 0; _x < xVals.length; _x++) {
        newColLink.push({expected: Number(xVals[_x]), value: scoreList[_y][_x]})
      }
      irData2.push({actual: xVals[_y], links: newColLink});
      valueLength2++;
    }
    return irData2
  }



  
  renderGeneral() {
    this.tabselector = 'tab1';
    }

  renderIR() {
    this.tabselector = 'tab2';
    }


  renderTest() {
    this.tabselector = 'tab3';
    this.updateScores();
  }

  updateElement(type, index, attribute, newValue){

    if (this.expectedDoubleValue) {

      if (newValue != this.expectedDoubleValue ) {
        newValue = newValue[0]
      }
      else if ((newValue != 10 && newValue != '10') && (newValue.length == 2) ){
          newValue = Number(newValue[1]);
        }
      else if (newValue.length == 3) {
        newValue = Number(newValue[2])
      }
    }
 
    if (type == 'qc') {
      this.qc[index][attribute] = newValue;
    }
    if (type == 'fraud') {
      this.fraud[index][attribute] = newValue;
    }
    if (type == 'pace') {
      this.pace[index][attribute] = newValue;
    }
  }

  appendElement(type) {

    if (type == 'qc') {
      this.qc.push({percentage: null, value: null});
    }
    else if (type == 'fraud') {
      this.fraud.push({percentage: null, value: null});
    }
  }

  removeElement(type, index) {

    if (type == 'qc') {
      this.qc.splice(index, 1)
    }
    else if (type == 'fraud') {
      this.fraud.splice(index, 1)
    }

  }

  selectTest(index, event) {
    this.tests[index]['testType'] = event.target.value
  }

  setTestValues(index, type, event){
    if (!Number.isNaN(Number(event))) {
        if (event != "") {
          event = Number(event);
        }
        else {
          event = null;
        }
    }
    else {
      event = null;
    }
    this.tests[index][type] = event
    this.updateScores();
  }

  updateTotalScore() {
    this.totalTestScore = 0;
    if ( Number(this.tests[0].value[0].value) >= this.starts[0].value || this.starts[0].value == null){
      for (var x=0; x < this.tests.length; x++) {
        var s = Number(this.tests[x].score)
        if (s == null){
          s = 0;
        }
        this.totalTestScore += Number(s);
      }
    }
    else {
      for (var x=0; x < this.tests.length; x++) {
        if (this.tests[x].testType != 'Starts' && this.tests[x].score != null){
          this.tests[x].score = 0
        } 
      }
    }
  }

  numberOnly(type, val, event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;

    this.expectedDoubleValue = null;

    if (type == 'percent'){
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          return false
      }

      return true; 
    }
   else if (type == 'penalty'){
    this.expectedDoubleValue = String(val) + event.key;

      if (!String(val) || charCode == 48){ // if key input is '0'
        if (String(val) == '0') {
          return false
        }
        return true
      }

      else if (charCode > 31 && (charCode < 48 || charCode > 57) ) { // 
        return false
      }

      else if (Number(val) == event.key) {
        return false
      }
      else if (charCode > 31 && (charCode < 48 || charCode > 57) ) {
        return false
      }     
      return true
    }
    return false;
  }

  updateScores() { 
    this.totalTestScore = 0;
    if (Number(this.tests[0].value) >= this.starts[0].value || this.starts[0].value == null){
      for (var x=0; x < this.tests.length; x++) {
        
        this.calculateTestScore(x);
        var s = this.tests[x].score
        if (!s){
          s = 0;
        }
        this.totalTestScore += Number(s);
      }
    }
    else {
      for (var x=0; x < this.tests.length; x++) {
        if (this.tests[x].testType != 'Starts' && this.tests[x].score != null){
          this.tests[x].score = 0
        } 
      }
    }
  }


  calculateTestScore(index){
    var t;
    var test = this.tests[index];
    if (test.testType == "IR") {
      t = this.ir

      if (test.expected != null && test.actual != null) {    
        var irExpected = null;
        var irActual = null;
        var i = 0;
        while ( i < t.length && !irActual){
          if (i + 1 < t.length) {
            if ((test.actual >= Number(t[i].actual)) && (test.actual <= Number(t[i+1].actual))){
              if ( (test.actual - Number(t[i].actual)) <= Number(t[i+1].actual) - test.actual) { // if test.actual is closer to or the same as t[i].actual
                irActual = t[i]
              }
              else {
                irActual = t[i+1]
              }
            }
            else if (test.actual <= Number(t[i].actual)){
              irActual = t[i]
            }
          }
          else if (test.actual >= Number(t[i].actual)){
           irActual = t[i]
          }
  
          i++;
        }

        if (irActual){
          i = 0;
          while ( i < irActual.links.length && !irExpected) {
            if (i + 1 < irActual.links.length) {
              if ((test.expected >= Number(irActual.links[i].expected)) && 
                (test.expected < Number(irActual.links[i+1].expected))) {
                if ( (test.expected - Number(irActual.links[i].expected)) <= Number(irActual.links[i+1].expected) - test.expected) { // if test.expected is closer to or the same as irActual.links[i].expected
                  irExpected = irActual.links[i]
                }
                else {
                  irExpected = irActual.links[i+1]
                }
              }
              else if (test.expected <= Number(irActual.links[i].expected)) {
                irExpected = irActual.links[i]
              }
            }
            else if (test.expected >= Number(irActual.links[i].expected)){
              irExpected = irActual.links[i]
            }
            var x = 1;
            var left_val = null;
            var right_val = null;
            if (irExpected && String(irExpected.value) == 'null') {
              while ( !right_val && i+x < irActual.links.length){
                if (irActual.links[i+x].value != null && irActual.links[i+x].value != ""){
                  right_val = irActual.links[i+x];
                }
                x++;
              }
              x = 1;
              while (!left_val && i-x >= 0){
                if (irActual.links[i-x].value != null && irActual.links[i-x].value != ""){
                  left_val = irActual.links[i-x];
                }
                x++;
              }

              if (!left_val){
                irExpected = null;
                i = irActual.links.length;
              }
              else if (!right_val) {
                irExpected = left_val;
              }
              else if ((test.expected - left_val.expected) <= (right_val.expected - test.expected)) {
                irExpected = left_val;
              }
              else {
                irExpected = right_val;
              }
            }
           i++;
          }
        }

        if (irExpected && Number(irExpected.value)) {

          this.tests[index].score = Number(irExpected.value)
        }
        else {
          this.tests[index].score = 0;
        }
      }
      else {
        this.tests[index].score = null;
      }
  }

    else if (test.testType == "QC" || test.testType == "Fraud") {
      t = test.testType == "QC" ? this.qc : this.fraud

      t.sort( this.sortValues('percentage'));

      if (test.rate != null) {
        var rate = null;
        var i = 0;
        while ( i < t.length && !rate){
          if (i + 1 < t.length) {
            if ((test.rate >= t[i].percentage) && (test.rate < t[i+1].percentage)){
            rate = t[i]
            }
          }
          else if (test.rate >= t[i].percentage){
           rate = t[i]
          }
          i++;
        }
        if (rate && rate.value) {
          this.tests[index].score = rate.value
        }
        else {
          this.tests[index].score = 0;
        }
      }
      else {
        this.tests[index].score = null;
      }
    }

    else if (test.testType == 'Pace') {
      t =this.pace[0]
      test.score = 0;
      if (test.negPace && t.negPace){
        test.score += t.negPace;
      }
    }
  }

  getAllConfigs(){
    this.configs = [];
    if (this.instanceId) {
      this.projectService.GetAllProjectHealthConfigs(this.instanceId).subscribe(data => {
        this.configs = data;
        for (var i=0; i< this.configs.length; i++) {
          this.configs[i].settings = JSON.parse(this.configs[i].settings)
        }
      }, error => {
         this.alertify.error('Unable to fetch project health configs');
      });
    }
  }

  cancelEdit(){
    this.configSelected = false;
    this.setup();
  }

  configNameChange(){
    this.configName = this.configName.trim();
    if (this.configName == '') {
      this.nameValid = false;
    }
    else {
      this.nameValid = true;
    }
  }

  saveHealthConfig(){

    this.configDesc == this.configDesc.trim();
    if (!this.nameValid || this.configName == '') {
      this.nameValid = false;
    }
    else {
      if (this.projectSettings.length <= 0){
        this.projectSettings = [
          {type: "qc", settings: this.qc}, 
          {type: "fraud", settings: this.fraud}, 
          {type: "ir", settings: this.ir}, 
          {type: "pace", settings: this.pace},
          {type: "starts", settings: this.starts}
        ];
      }
      var settings: string = JSON.stringify(this.projectSettings);
  
      if (this.selectedConfigId == '') {
        this.projectService.CreateProjectHealthConfig(this.instanceId, this.configName, this.configDesc, settings).subscribe( data => {
        // route to project
        this.alertify.success('Health Configuration saved.');
        this.getAllConfigs();
        this.selectedConfigId = '';
        this.configSelected = false;
        this.setup();
  
        }, error => {
          this.alertify.error('There was a problem with saving the configuration.');
  
        });
      }
      else {
        this.projectService.UpdateProjectHealthConfig(this.selectedConfigId, this.configName, this.configDesc, settings).subscribe( data => {
          // route to project
          this.configSelected = false;
          this.setup();
        this.alertify.success('Health Configuration updated.');



  
        }, error => {
          this.alertify.error('There was a problem with updating the configuration.');
  
        });
      }

    }
    

  }

  sortValues(att) {
    return function(a,b){
      if (a[att] > b[att]) {
          return 1;
      } else if(a[att] < b[att]){
          return -1;
      }
      return 0;
    }
  }
}
